export const CHANGE_LOCALE = "app/LanguageToggle/CHANGE_LOCALE";
